import React from 'react';
import AuthPage from 'app/routes/AuthPage';
import {Helmet} from 'react-helmet-async';

const SignUpPage = () => {
  const props = {
    type: 'signup',
    headline: 'Konto erstellen',
    subtitle: 'Werde Teil der Community',
    emailButtonLabel: 'Mit E-Mail registrieren',
    emailButtonLinkTo: '/auth/signup/email',
    hintText: 'Du hast bereits ein FuPa-Konto? ',
    hintLinkedText: 'Einloggen',
    hintLinkTo: '/auth/login',
  };
  const meta = [
    {name: 'description', content: 'Erstelle jetzt kostenlos dein FuPa-Konto und präsentiere deinen Verein.'},
  ];

  return (
    <>
      <Helmet title='Registrieren' meta={meta}>
        <link rel='canonical' href='https://www.fupa.net/auth/signup' />
      </Helmet>
      <AuthPage {...props} />
    </>
  );
};

export default SignUpPage;
